import { GtagKeys } from 'constants/analytics';

export const setGtagClientId = () => {
    if (window.gtag) {
        window.gtag('get', 'G-ESGYMC55W3', 'client_id', (clientId: string) => {
            localStorage.setItem(GtagKeys.gtagClientId, clientId);
        });
    }
};
